module.exports = __webpack_public_path__ + "static/media/03_01_03.d88f64e2.png";